// extracted by mini-css-extract-plugin
export default {"table":"table_table__hiyWB","row":"table_row__9vbUz","headerCell":"table_headerCell__nqg-D","cell":"table_cell__zfKli"};